<div [dir]="textDir()"><router-outlet></router-outlet></div>

<p-toast
  [style]="{ marginTop: '80px' }"
  [baseZIndex]="10000"
  key="main"
></p-toast>
